// import province from '../constants/province';

const province = require('../constants/provinces-constants');

// 处理ocr数据到表单对象中
export default {

  /**
   * orc信息注入（已检查）
   *
   * @param {Object} dataModel 申请表数据
   * @param {Object} idcard 身份证信息
   * @param {Object} passport 护照信息
   * @param {Object} visaType 签证类型
   * @returns {Object}
   */
  fromOcr(dataModel, applyFields, idcard, passport, visaType, departDate) {
    // const result = Extend({}, dataModel);
    const result = Object.assign({}, dataModel);

    const ocrData = this.idcardAndPassport(idcard, passport, visaType, departDate);


    // 遍历申请表配置对象中的所有组
    applyFields.forEach((group) => {
      // 遍历所有组中的所有字段
      group.fields.forEach((field) => {
        if (!field.ocr) return;

        let value = '';
        if (typeof field.ocr === 'function') {
          // 函数形式
          try {
            value = field.ocr(ocrData);
          } catch (error) {
            value = '';
          }
        } else {
          // 普通形式
          value = ocrData[field.ocr];
        }

        // 设置到结果上
        if (value !== undefined && value !== '') {
          result[field.name] = value;
        }
      });
    });

    return result;
  },

  // 如果是0000-00-00也视为空
  getDate(date) {
    if (date) {
      if (date === '0000-00-00') {
        return '';
      } else if (date === '3000-01-01') {
        // 身份证长期有效
        return '';
      }
      return date;
    }
    return '';
  },

  /**
   * ocr信息初始化（已检查）
   *
   * @param {Object} idcard 身份证信息
   * @param {Object} passport 护照信息
   * @param {Object} visaType 商品信息
   * @param {Object} depart_date 出行日期
   * @returns {Object}
   */
  idcardAndPassport(idcard, passport, visaType, departDate) {
    let gender = '';

    if (passport.gender === 0 || passport.gender === 1) {
      gender = passport.gender.toString();
    } else if (idcard.gender === 0 || idcard.gender === 1) {
      gender = idcard.gender.toString();
    } else {
      gender = '';
    }

    return {
      fullname: passport.fullname || idcard.fullname, // 优先取护照的名字
      fullname_pinyin: `${passport.surname_pinyin || ''} ${passport.name_pinyin || ''}`,
      gender, // 优先取护照信息
      birthday: this.getDate(passport.birthday || idcard.birthday),

      id_issue_date: this.getDate(idcard.issue_date),
      id_expire_date: this.getDate(idcard.expire_date),
      id_expire_date_long_time: idcard.expire_date === '3000-01-01' ? '1' : '0',
      issue_authority: idcard.issue_authority,
      id_no: idcard.id_no,
      id_nation: idcard.nation,
      id_address: idcard.address,

      ps_issue_date: this.getDate(passport.issue_date),
      ps_expire_date: this.getDate(passport.expire_date),
      surname_cn: passport.surname_cn,
      surname_pinyin: passport.surname_pinyin,
      name_cn: passport.name_cn,
      name_pinyin: passport.name_pinyin,
      passport_number: passport.passport_number,
      birth_place_cn: this.getOtherProvince(passport, 'birth_place_cn'),
      other_birth_place_cn: this.getOtherProvince(passport, 'birth_place_cn') === '其它' ? passport.birth_place_cn : undefined,
      birth_place_pinyin: passport.birth_place_pinyin,
      issue_place_cn: this.getOtherProvince(passport, 'issue_place_cn'),
      other_issue_place_cn: this.getOtherProvince(passport, 'issue_place_cn') === '其它' ? passport.issue_place_cn : undefined,
      issue_place_pinyin: passport.issue_place_pinyin,
      issue_authority_cn: passport.issue_authority_cn,
      issue_authority_en: passport.issue_authority_en,
      // 下面都是商品相关的信息
      visa_type: visaType.toString(),
      depart_date: departDate,
      country_code: passport.country_code,
    };
  },

  getOtherProvince(passport, key) {
    if (passport[key] && province.default.indexOf(passport[key]) === -1) {
      return '其它';
    }
    return passport[key];
  },
};



// WEBPACK FOOTER //
// ./src/libs/ocr.js